<div>
  <div class="w-100 text-center mb-3 d-sm-flex justify-content-center">
    <span class="d-inline-flex align-items-center">
      <h1>Conference Eligibility</h1>
    </span>
  </div>

  <div class="card mt-2" *ngIf="configuration">
    <div class="card-body">
      <button class="btn btn-primary float-right" [disabled]="savingConfiguration" (click)="saveConfiguration()">
        <i class="fas fa-save"></i> Save
      </button>
      <h2>Global Rules</h2>
      <i *ngIf="loadingConfiguration" class="material-icons rotate text-muted">loop</i>

      <div class="row mt-3">
        <div class="col-12 col-md-3 mt-2">
          <b>Accrual Start Date</b>
          <input type="date" class="form-control mt-2" [(ngModel)]="configuration.settings.accrualStartDate" />
        </div>
        <div class="col-12 col-md-3 mt-2">
          <b>KRA Threshold</b>
          <input type="number" min="0" max="100" step="0.01" class="form-control mt-2" [(ngModel)]="configuration.settings.kraThreshold" />
        </div>
        <div class="col-12 col-md-3 mt-2">
          <b>File Review Threshold</b>
          <input type="number" min="0" max="100" step="0.01" class="form-control mt-2" [(ngModel)]="configuration.settings.fileReviewThreshold" />
        </div>
        <div class="col-12 col-md-3 mt-2">
          <b>Good Standing Lookback Months</b>
          <input type="number" min="0" step="1" class="form-control mt-2" [(ngModel)]="configuration.settings.goodStandingLookbackMonths" />
        </div>
        <div class="col-12 col-md-3 mt-2">
          <b>Local/National Advance Days</b>
          <input type="number" min="0" step="1" class="form-control mt-2" [(ngModel)]="configuration.settings.localNationalAdvanceDays" />
        </div>
        <div class="col-12 col-md-3 mt-2">
          <b>International Advance Days</b>
          <input type="number" min="0" step="1" class="form-control mt-2" [(ngModel)]="configuration.settings.internationalAdvanceDays" />
        </div>
        <div class="col-12 col-md-3 mt-4">
          <label class="mt-4">
            <input type="checkbox" [(ngModel)]="configuration.settings.enableGoodStandingRule" />
            Good standing required
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3" *ngIf="configuration">
    <div class="card-body">
      <button class="btn btn-secondary float-right" (click)="newRoleCategory()">
        <i class="fas fa-plus"></i> New Role Category
      </button>
      <h2>Role Categories</h2>

      <p-table [value]="configuration.roleCategories" [responsive]="true">
        <ng-template pTemplate="header">
          <tr>
            <th width="120px"></th>
            <th>Name</th>
            <th>Job Titles</th>
            <th>Eligible Levels</th>
            <th>File Review</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-roleCategory>
          <tr>
            <td>
              <span class="pointer mr-2" (click)="editRoleCategory(roleCategory)">
                <i title="Edit Role Category" class="fas fa-edit"></i>
              </span>
              <span class="pointer mr-2" (click)="archiveRoleCategory(roleCategory)">
                <i title="Archive Role Category" class="fas fa-archive"></i>
              </span>
            </td>
            <td>{{roleCategory.name}}</td>
            <td>{{getJobTitleLabels(roleCategory.jobTitleIDs)}}</td>
            <td>{{getLevelRulesSummary(roleCategory)}}</td>
            <td>{{roleCategory.appliesFileReviewRule ? 'Required for caseload' : 'Not required'}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="card mt-3" *ngIf="configuration">
    <div class="card-body">
      <button class="btn btn-secondary float-right" (click)="newOpportunity()">
        <i class="fas fa-plus"></i> New Opportunity
      </button>
      <h2>Conference Opportunities</h2>
      <i *ngIf="loadingOpportunities" class="material-icons rotate text-muted">loop</i>

      <p-table [value]="opportunities" [responsive]="true">
        <ng-template pTemplate="header">
          <tr>
            <th width="120px"></th>
            <th>Title</th>
            <th>Level</th>
            <th>Dates</th>
            <th>Application Deadline</th>
            <th>Status</th>
            <th>Participants</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-opportunity>
          <tr>
            <td>
              <span class="pointer mr-2" (click)="editOpportunity(opportunity)">
                <i title="Edit Opportunity" class="fas fa-edit"></i>
              </span>
              <span class="pointer mr-2" (click)="archiveOpportunity(opportunity)">
                <i title="Archive Opportunity" class="fas fa-archive"></i>
              </span>
            </td>
            <td>{{opportunity.title}}</td>
            <td>{{opportunity.levelLabel || getLevelLabel(opportunity.levelID)}}</td>
            <td>{{opportunity.startDate}} - {{opportunity.endDate}}</td>
            <td>{{opportunity.applicationDeadline || '-'}}</td>
            <td>{{opportunity.statusLabel || getOpportunityStatusLabel(opportunity.statusID)}}</td>
            <td>{{opportunity.maxRecommendedParticipants || '-'}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog header="Role Category" [focusTrap]="false" [modal]="true" [style]="{width: '80vw'}" [(visible)]="openRoleCategory">
  <div *ngIf="selectedRoleCategory">
    <div class="row">
      <div class="col-12 col-md-6 mt-2">
        <b>Name</b>
        <input type="text" class="form-control mt-2" [(ngModel)]="selectedRoleCategory.name" />
      </div>
      <div class="col-12 col-md-6 mt-2">
        <b>Job Titles</b>
        <p-multiSelect class="w-100" styleClass="w-100 d-flex mt-2" inputStyleClass="form-control" [options]="jobTitleOptions"
                       optionLabel="label" optionValue="value"
                       [(ngModel)]="selectedRoleCategory.jobTitleIDs" [filter]="true" placeholder="Select job titles..."></p-multiSelect>
      </div>
      <div class="col-12 mt-2">
        <b>Description</b>
        <textarea class="form-control mt-2" rows="2" [(ngModel)]="selectedRoleCategory.description"></textarea>
      </div>
      <div class="col-12 mt-3">
        <label>
          <input type="checkbox" [(ngModel)]="selectedRoleCategory.appliesFileReviewRule" />
          File review score applies when the employee has an active caseload
        </label>
      </div>
    </div>

    <p-table class="mt-3" [value]="selectedRoleCategory.levelRules" [responsive]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Level</th>
          <th width="140px">Eligible</th>
          <th width="220px">Required Hours</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rule>
        <tr>
          <td>{{rule.levelLabel || getLevelLabel(rule.levelID)}}</td>
          <td>
            <input type="checkbox" [(ngModel)]="rule.isEligible" />
          </td>
          <td>
            <input type="number" min="0" step="0.01" class="form-control" [(ngModel)]="rule.requiredHours" [disabled]="!rule.isEligible" />
          </td>
        </tr>
      </ng-template>
    </p-table>

    <button class="btn btn-primary mt-3" [disabled]="savingConfiguration" (click)="saveRoleCategory()">
      <i class="fas fa-save"></i> Save Role Category
    </button>
  </div>
</p-dialog>

<p-dialog header="Conference Opportunity" [focusTrap]="false" [modal]="true" [style]="{width: '80vw'}" [(visible)]="openOpportunity">
  <div *ngIf="selectedOpportunity">
    <div class="row">
      <div class="col-12 col-md-6 mt-2">
        <b>Title</b>
        <input type="text" class="form-control mt-2" [(ngModel)]="selectedOpportunity.title" />
      </div>
      <div class="col-12 col-md-6 mt-2">
        <b>Location</b>
        <input type="text" class="form-control mt-2" [(ngModel)]="selectedOpportunity.location" />
      </div>
      <div class="col-12 col-md-4 mt-2">
        <b>Level</b>
        <p-select styleClass="app-select mt-2 w-100" [options]="configuration.levels" optionLabel="label" optionValue="value"
                  [(ngModel)]="selectedOpportunity.levelID"></p-select>
      </div>
      <div class="col-12 col-md-4 mt-2">
        <b>Status</b>
        <p-select styleClass="app-select mt-2 w-100" [options]="configuration.opportunityStatuses" optionLabel="label" optionValue="value"
                  [(ngModel)]="selectedOpportunity.statusID"></p-select>
      </div>
      <div class="col-12 col-md-4 mt-2">
        <b>Max Recommended Participants</b>
        <input type="number" min="0" step="1" class="form-control mt-2" [(ngModel)]="selectedOpportunity.maxRecommendedParticipants" />
      </div>
      <div class="col-12 col-md-4 mt-2">
        <b>Start Date</b>
        <input type="date" class="form-control mt-2" [(ngModel)]="selectedOpportunity.startDate" />
      </div>
      <div class="col-12 col-md-4 mt-2">
        <b>End Date</b>
        <input type="date" class="form-control mt-2" [(ngModel)]="selectedOpportunity.endDate" />
      </div>
      <div class="col-12 col-md-4 mt-2">
        <b>Application Deadline</b>
        <input type="date" class="form-control mt-2" [(ngModel)]="selectedOpportunity.applicationDeadline" />
      </div>
      <div class="col-12 mt-2">
        <b>Description</b>
        <textarea class="form-control mt-2" rows="4" [(ngModel)]="selectedOpportunity.description"></textarea>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between mt-4">
      <h3 class="mb-0">Application Questions</h3>
      <button type="button" class="btn btn-secondary btn-thin" (click)="addQuestion()">
        <i class="fas fa-plus"></i> Add Question
      </button>
    </div>

    <div class="border-top mt-3 pt-3" *ngFor="let question of selectedOpportunity.questions; let questionIndex = index">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <b>Question {{questionIndex + 1}}</b>
        <div>
          <button type="button" class="btn btn-link p-1" title="Move question up"
                  [disabled]="questionIndex === 0" (click)="moveQuestion(questionIndex, -1)">
            <i class="fas fa-arrow-up"></i>
          </button>
          <button type="button" class="btn btn-link p-1" title="Move question down"
                  [disabled]="questionIndex === selectedOpportunity.questions.length - 1" (click)="moveQuestion(questionIndex, 1)">
            <i class="fas fa-arrow-down"></i>
          </button>
          <button type="button" class="btn btn-link text-danger p-1" title="Remove question"
                  (click)="removeQuestion(questionIndex)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-7 mt-2">
          <b>Prompt</b>
          <input type="text" class="form-control mt-2" maxlength="1000" [(ngModel)]="question.prompt" />
        </div>
        <div class="col-12 col-md-3 mt-2">
          <b>Answer Type</b>
          <p-select styleClass="app-select mt-2 w-100" [options]="configuration.questionTypes"
                    optionLabel="label" optionValue="value" [(ngModel)]="question.questionTypeID"
                    (onChange)="onQuestionTypeChanged(question)"></p-select>
        </div>
        <div class="col-12 col-md-2 mt-4">
          <label class="mt-4">
            <input type="checkbox" [(ngModel)]="question.isRequired" />
            Required
          </label>
        </div>
        <div class="col-12 mt-2">
          <b>Help Text <span class="text-muted">(optional)</span></b>
          <input type="text" class="form-control mt-2" maxlength="2000" [(ngModel)]="question.helpText" />
        </div>
      </div>

      <div class="mt-3" *ngIf="questionRequiresOptions(question)">
        <div class="d-flex align-items-center justify-content-between">
          <b>Choices</b>
          <button type="button" class="btn btn-link p-1" (click)="addQuestionOption(question)">
            <i class="fas fa-plus"></i> Add Choice
          </button>
        </div>
        <div class="input-group mt-2" *ngFor="let option of question.options; let optionIndex = index">
          <input type="text" class="form-control" [(ngModel)]="question.options[optionIndex]"
                 [attr.aria-label]="'Choice ' + (optionIndex + 1)" />
          <div class="input-group-append">
            <button type="button" class="btn btn-outline-danger" title="Remove choice"
                    (click)="removeQuestionOption(question, optionIndex)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <p class="text-muted mt-3" *ngIf="!selectedOpportunity.questions?.length">
      No custom questions are configured for this opportunity.
    </p>

    <button class="btn btn-primary mt-3" [disabled]="savingOpportunity" (click)="saveOpportunity()">
      <i class="fas fa-save"></i> Save Opportunity
    </button>
  </div>
</p-dialog>
